<template>
  <div>
    <div class="container scroll-list-wrap" :class="btnText !== '应用' ? '' : 'noBtn'">
      <cube-scroll ref="scroll">
        <channel-unit :name="name" :type="type" :img="iconUrl" :effecDate="effecDate" :crowdfund=crowdfund></channel-unit>
        <div class="canlexplain">
          <h4 class="title">日历频道说明</h4>
          <p>{{content}}</p>
          <p v-if="scontent">{{decontent}}</p>
        </div>
        <div class="canlstyle">
          <h4 class="title">日历样式展示</h4>
          <cube-scroll
            ref="scroll"
            :data="items"
            direction="horizontal"
            class="pic-container">
            <ul class="list-wrapper">
              <li class="pic" v-for="(item, i) in items" :key="i" :style="{backgroundImage: 'url('+ item +')'}"></li>
            </ul>
          </cube-scroll>
          <!-- <div class="pic-container">
            <div class="pic"></div>
            <div class="pic"></div>
          </div> -->
        </div>
      </cube-scroll>
    </div>
    <div class="button-container" v-if="btnText !== '应用'">
      <button class="btn-block" ref="buyBtn" @click="buy()">{{btnText}}</button>
    </div>
    <ttip-select v-if="showSelectTip" @cancel="cancel" @sure="sure" :text="text" sub="true" rightName="是" leftName="否"></ttip-select>
  </div>
</template>
<script>
import ChannelUnit from './components/ChannelUnit.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import axios from 'axios'
import Common from '../../assets/js/common.js'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    ChannelUnit,
    TtipSelect
  },
  data () {
    return {
      deviceId: localStorage.getItem('max_device_id'),
      userId: localStorage.getItem('max_userId'),
      name: '',
      type: '',
      content: '',
      scontent:false,
      decontent:'',
      iconUrl: '',
      price: this.$route.query.price,
      priceId: this.$route.query.priceId,
      channel: this.$route.query.channel,
      other: this.$route.query.other,
      isUse: this.$route.query.isUse,
      crowdfund: this.$route.query.crowdfund,
      year: '2019',
      appId: localStorage.getItem('appId'),
      timeStamp: null,
      nonceStr: null,
      package: null,
      signType: null,
      paySign: null,
      items: ['', ''],
      effecDate: '',
      btnText: '应用',
      showSelectTip: false,
      text: '该商品不支持退换，是否继续支付？'
    }
  },
  methods: {
    sure () {
      // 继续支付
      this.showSelectTip = false
      this.getBuyParams()
    },
    cancel () {
      // 取消支付
      this.showSelectTip = false
    },
    getBuyParams () {
      // console.log('userID = ' + this.userId + 'channel = ' + this.channel + 'priceId =' +this.priceId)
      /* this.toast = this.$createToast({
        time: 0,
        txt: '请稍等',
        mask: true
      }).show() */
      if (isLocal === 'local') {
        axios.post('/Calendar/api/channel/buy/channel/', {
          'user_id': this.userId,
          'channel': this.channel,
          'channel_price_id': this.priceId,
          'device_id': this.deviceId
        })
        .then(this.getBuyParamsSucc)
        .catch(this.getBuyParamsErr)
      } else {
        axios.post(api + '/Calendar/api/channel/buy/channel/', {
          'user_id': this.userId,
          'channel': this.channel,
          'channel_price_id': this.priceId,
          'device_id': this.deviceId
        })
        .then(this.getBuyParamsSucc)
        .catch(this.getBuyParamsErr)
      }
    },
    getBuyParamsSucc (res) {
      let _res = res.data
      let _this = this
      if (_res.result === 0) {
        // console.log(JSON.stringify(_res.info))
        let info = _res.info
        _this.timeStamp = info.timeStamp
        _this.nonceStr = info.nonceStr
        _this.package = info.package
        _this.signType = info.signType
        _this.paySign = info.paySign
        if (typeof WeixinJSBridge === 'undefined') {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady(_this), false)
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady(_this))
            document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady(_this))
          }
        } else {
          _this.onBridgeReady(_this)
        }
      } else {
        console.log(_res.message)
      }
    },
    getBuyParamsErr (error) {
      console.log(error)
    },
    getChannelInfo () {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在获取频道信息',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/channel/get/exhibition/channel/info/', {
          'calendar_id': Number(this.channel)
        })
        .then(this.getChannelInfoSucc)
        .catch(this.getChannelInfoErr)
      } else {
        axios.post(api + '/Calendar/api/channel/get/exhibition/channel/info/', {
          'calendar_id': Number(this.channel)
        })
        .then(this.getChannelInfoSucc)
        .catch(this.getChannelInfoErr)
      }
    },
    getChannelInfoSucc (res) {
      // console.log('获取频道信息'+ JSON.stringify(res.data.calendar_info))
      this.toast.hide()
      let _res = res.data
      if (_res.result === 0) {
        let info = _res.calendar_info
        this.iconUrl = info.icon_url
        this.name = info.name
        if (info.price === 0) {
          this.type = '免费使用'
        } else {
          this.type = '¥' + info.price
        }
        var str=info.contents;
        var search = "r";
        var start = str.indexOf(search);//获得字符串的开始位置
        var result1 = str.substring(0,start-1);//截取字符串
        var result2 = str.substring(start+3,str.length);//截取字符串
        if (result1.length >1) {
          this.scontent = true;
          this.content = result1;
          this.decontent = result2;
        }
        else{
          this.content = info.contents
        }
        this.items = info.images_url_list
        let effecDate = info.effective_date
        if (effecDate === 0) {
          this.effecDate = '无限'
        } else {
          let startDate = Common.timestampToTime(effecDate.start_date * 1000, 'YY¥MM¥DD')
          let endDate = Common.timestampToTime(effecDate.end_date * 1000, 'YY¥MM¥DD')
          this.effecDate = startDate + '至' + endDate
        }
        let isEffect = info.is_it_effective
        if (this.other === 'other') {
          this.btnText = '购买  ¥' + info.price
        } else {
          if (isEffect !== 1) {
            this.setBtnDis()
          }
        }
        // console.log(info.name)
      } else {
        console.log(_res.message)
      }
    },
    setBtnDis () {
      this.$refs.buyBtn.setAttribute('disabled', 'disabled')
      this.$refs.buyBtn.style.backgroundColor = '#64747d'
    },
    getChannelInfoErr (error) {
      // this.toast.hide()
      this.setBtnDis()
      this.toast.hide()
      this.toast = this.$createToast({
        txt: '加载失败，请稍后重试！',
        type: 'txt'
      }).show()
      console.log(error)
    },

    buy () {
      this.text = '是否要购买' + this.effecDate + this.name
      this.showSelectTip = true
    },
    onBridgeReady (_this) {
      // alert(_this.timeStamp)
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          'appId': _this.appId,
          'timeStamp': _this.timeStamp + '',
          'nonceStr': _this.nonceStr,
          'package': _this.package,
          'signType': _this.signType,
          'paySign': _this.paySign
        },
        function (res) {
          // console.log('微信回调'+res.err_msg)
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            localStorage.setItem('max_channel_from', 'detail')
            localStorage.setItem('max_channel_change', 'true')
            _this.$router.push({path: '/CutStyle'})
          } else {
            _this.toast = _this.$createToast({
              txt: '支付失败，请稍后重试！',
              type: 'txt'
            }).show()
          }
        }
      )
    }
  },
  mounted () {
    Common.setTitle('频道详情 ')
    this.getChannelInfo()
    localStorage.setItem('max_channel_change', 'false')
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl';
  .container
    background #ffffff
    padding-left 15px
    box-sizing border-box
    height calc(100vh - 9.12vh)
    overflow-y auto
    position relative
    .btn
      width 90px
      position absolute
      top 40px
      right 20px
      z-index 2
    .title
      font-size 16px
      color #000000
      font-weight 600
    .canlexplain
      p
        color #767676
        font-size 15px
        line-height 21px
        padding-right 15px
        padding-top 1.9vh
    .canlstyle
      padding-top 2.9vh
      .pic-container
        padding-top 1.65vh
        >>>.cube-scroll-content
          display inline-block
        .list-wrapper
          white-space nowrap
          .pic
            height 53vh
            width calc(53vh / 1.35)
            border 1px solid #000000
            margin-right 14px
            display inline-block
            background-position center center
            background-repeat no-repeat
            background-size contain
  .button-container
    height 9.12vh
    background #ffffff
    rowCloCenter()
    box-shadow 0 -5px 8px rgba(0,0,0,.1)
    position absolute
    z-index 2
    width 100vw
    bottom 0
    .btn-block
      height 80%
      width 90%
      border-radius 2px
  .noBtn
    height 100vh
</style>


// WEBPACK FOOTER //
// src/pages/ChannelDetail/ChannelDetail.vue